export function createServiceMessage(...args: unknown[]) {
	switch (args[0]) {
		case 'auth':
			return JSON.stringify({
				service: 'auth',
				data: { session_id: args[1], login_params: 'param' }
			});
		case 'settings':
			return JSON.stringify({ service: 'settings', data: args[1] });
		case 'cashout':
			return JSON.stringify({
				service: 'cashout',
				data: { index: args[1] }
			});
		case 'bet':
			return JSON.stringify({
				service: 'bet',
				data: { amount: args[1], index: args[2], auto: args[3] }
			});
		case 'ping':
			return JSON.stringify({ service: 'ping', data: {} });
		default:
			break;
	}
	return '';
}
